<template>
  <div class="search_result">
    <div class="tit">
      <div class="m">
        <div class="tab">
          <el-tabs v-model="activeName">
            <el-tab-pane label="毕业展" name="0"></el-tab-pane>
            <el-tab-pane label="毕设作品" name="1"></el-tab-pane>
            <el-tab-pane label="毕业生" name="2"></el-tab-pane>
            <el-tab-pane label="明星院校" name="3"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="search_box">
          <input v-model="searchText" type="text" @keyup.enter="reSearch" placeholder="输入搜索的内容" />
          <i class="my_icon white_search" @click="reSearch"></i>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="m">
        <!-- <router-view></router-view> -->
        <result_task v-if="activeName === '0'" ref="0" :searchText="searchText"></result_task>
        <result_works v-if="activeName === '1'" ref="1" :searchText="searchText"></result_works>
        <result_designer v-if="activeName === '2'" ref="2" :searchText="searchText"></result_designer>
        <result_course v-if="activeName === '3'" ref="3" :searchText="searchText"></result_course>
      </div>
    </div>
  </div>
</template>

<script>
import result_task from "@/views/search_result/task/index.vue";
import result_course from "@/views/search_result/course/index.vue";
import result_works from "@/views/search_result/works/index.vue";
import result_designer from "@/views/search_result/designer/index.vue";
export default {
  components: {
    result_task,
    result_course,
    result_works,
    result_designer
  },
  data() {
    return {
      searchText: "",
      activeName: "0"
    };
  },
  created() {
    // 初始化搜索框默认文字内容
    this.searchText = this.$route.query.searchText;
  },
  methods: {
    //触发子组件重新根据搜索文字获取结果
    reSearch() {
      if (!this.searchText) return;
      this.$refs[this.activeName].search();
    }
  },
  watch: {
    $route() {
      //监听搜索输入的变化改变搜索框默认文字内容
      this.searchText = this.$route.query.searchText;
    }
  }
};
</script>

<style lang="scss">
.search_result {
  .tit {
    background: #fff;
    .m {
      display: flex;
      height: 110px;
      justify-content: space-between;
      align-items: center;
    }
    // .tab {
    //   display: flex;
    //   li {
    //     margin-right: 50px;
    //     position: relative;
    //     a {
    //       font-size: 16px;
    //       color: $font-gary;
    //     }
    //   }
    //   li.active {
    //     a {
    //       color: $font-black;
    //     }
    //   }
    //   li.active::after {
    //     content: "";
    //     width: 29px;
    //     height: 3px;
    //     background: #111;
    //     position: absolute;
    //     z-index: 1;
    //     bottom: -47px;
    //     left: 0;
    //     right: 0;
    //     margin: 0 auto;
    //   }
    // }
    .tab {
      .el-tabs {
        height: 110px;
        .el-tabs__header {
          height: 100%;
          .el-tabs__nav-wrap {
            height: 100%;
            .el-tabs__nav-scroll {
              height: 100%;
              .el-tabs__nav {
                height: 100%;
                display: flex;
                align-items: center;
                .el-tabs__item {
                  font-size: 16px;
                  color: #999;
                  padding: 0;
                  margin: 0 20px;
                }
                .el-tabs__item:nth-child(2) {
                  margin-left: 0;
                }
                .el-tabs__item.is-active {
                  color: #333;
                }
                .el-tabs__item.is-active::after {
                  content: "";
                  width: 29px;
                  height: 3px;
                  background: #111;
                  position: absolute;
                  z-index: 1;
                  bottom: -35px;
                  left: 0;
                  right: 0;
                  margin: 0 auto;
                }
                .el-tabs__active-bar {
                  height: 0;
                }
              }
            }
          }
          .el-tabs__nav-wrap::after {
            height: 0;
          }
        }
      }
    }
    .search_box {
      display: flex;
      align-items: center;
      width: 350px;
      height: 44px;
      padding: 0 20px;
      border: 1px solid #e6e6e6;
      border-radius: 22px;
      input {
        flex: 1;
        font-size: 16px;
        color: $font-black;
        border: none;
        outline: none;
      }
    }
  }
  .content {
    // 搜索结果公共样式
    .result_box {
      margin-top: 20px;
      margin-bottom: 60px;
      .result_list_box {
        display: flex;
        flex-wrap: wrap;
        // justify-content: space-between;
        .opus_item {
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
